import { PowerlossCalculationChartTabParams } from '../models/chart/PowerlossCalculationChartTabParams';

export const DEFAULT_POWERLOSS_CHART_TAB_PARAMS: PowerlossCalculationChartTabParams = {
    powerLossAtRequiredShaftPower: false,
    showReferenceIesPowerLoss: false
};
